import React from 'react'
import { useNavigate } from 'react-router'
import { useMount } from 'react-use'
import { match } from 'ts-pattern'
import { type LiteralUnion } from 'type-fest'

import { LoadingPanel } from '~/components/elements/LoadingPanel'
import { ErrorPanel } from '~/components/features/ErrorPanel'

type GetRedirectPathResult =
  | {
      success: false
      error: string
    }
  | {
      success: true
      path: string
      state?: unknown
    }

export type RedirectOrErrorProps = {
  getRedirectPath: () => GetRedirectPathResult
}

export const RedirectOrError = ({ getRedirectPath }: RedirectOrErrorProps) => {
  const [stateOrError, setStateOrError] =
    React.useState<LiteralUnion<'complete' | 'processing', string>>(
      'processing',
    )
  const navigate = useNavigate()

  useMount(() => {
    const result = getRedirectPath()

    if (result.success) {
      navigate(result.path, { state: result.state, replace: true })
      setStateOrError('complete')
    } else {
      setStateOrError(result.error)
    }
  })

  return match(stateOrError)
    .with('processing', () => <LoadingPanel containerSize="full" />)
    .with('complete', () => null)
    .otherwise((message) => <ErrorPanel message={message} />)
}
